export enum ApplicationLocalStorageKey {
  MERCHANT_VERTICAL = 'merchantVertical',
  LOAN_APPLICATION_ORIGIN = 'loanApplicationOrigin',
  REFERER = 'referer',
}
